/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export enum ActionType {
  ORIGINAL = "original",
  GENERATE_EXTERNAL_SUMMARY = "generate_external_summary",
  GENERATE_INTERNAL_SUMMARY = "generate_internal_summary",
  FINISH_EXTERNAL_SUMMARY = "finish_external_summary",
  FINISH_INTERNAL_SUMMARY = "finish_internal_summary",
}
